import Vue from "vue";
import Vuex from "vuex";

import categoryGroups from "./categoryGroups";
import categories from "./categories";
import subcategories from "./subcategories";
import brands from "./brands";
import products from "./products";
import catalogs from "./catalogs";
import team from "./team";
import landingPage from "./landingPage";
import ranges from "./ranges";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    categoryGroups,
    categories,
    subcategories,
    brands,
    products,
    catalogs,
    team,
    landingPage,
    ranges
  }
});
